import React from 'react';
import { Button, Card, CardContent, Typography } from '@mui/material';
import { createSubtleIceSurface } from '../../theme/surfaces';

interface EmptyStateCardProps {
  message: string;
  actionLabel?: string;
  actionIcon?: React.ReactNode;
  onAction?: () => void;
  actionDisabled?: boolean;
  helperText?: string;
}

export const EmptyStateCard: React.FC<EmptyStateCardProps> = ({
  message,
  actionLabel,
  actionIcon,
  onAction,
  actionDisabled = false,
  helperText,
}) => (
  <Card sx={createSubtleIceSurface(234, { })}>
    <CardContent sx={{ textAlign: 'center', py: 3 }}>
      <Typography color="textSecondary" sx={{ mb: actionLabel ? 2 : 0 }}>
        {message}
      </Typography>
      {actionLabel && onAction && (
        <Button
          size="small"
          variant="contained"
          startIcon={actionIcon}
          onClick={onAction}
          disabled={actionDisabled}
        >
          {actionLabel}
        </Button>
      )}
      {helperText && (
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ display: 'block', mt: 1 }}
        >
          {helperText}
        </Typography>
      )}
    </CardContent>
  </Card>
);
